export const handleColor = (coef: string) => {
  const value = Number(coef)
  if (value >= 0 && value < 3) return "#FFB000"
  if (value >= 3 && value < 10) return "#DC5BE8"
  if (value >= 10 && value < 20) return "#FF5C00"
  if (value >= 20 && value < 30) return "#0047FF"
  if (value >= 30) return "#CB1212"
  return "#ffb000˝"
}
